<template>
  <div class="DisplayOptions">
    <a @click.prevent="toggleDisplay()" class="showGrid" :class="{ active: isActive() === 'grid' }">
      <svg v-if="isActive() === 'grid'" width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="search---results---grid" transform="translate(-1321.000000, -394.000000)">
            <g id="Group-4" transform="translate(1321.000000, 394.000000)">
              <rect id="Rectangle-55" fill="#0033A0" x="0" y="0" width="45" height="45"></rect>
              <path d="M10,16 L16,16 L16,10 L10,10 L10,16 Z M19,16 L25,16 L25,10 L19,10 L19,16 Z M28,10 L28,16 L34,16 L34,10 L28,10 Z M10,25 L16,25 L16,19 L10,19 L10,25 Z M19,25 L25,25 L25,19 L19,19 L19,25 Z M28,25 L34,25 L34,19 L28,19 L28,25 Z M10,34 L16,34 L16,28 L10,28 L10,34 Z M19,34 L25,34 L25,28 L19,28 L19,34 Z M28,34 L34,34 L34,28 L28,28 L28,34 Z"
                id="Fill-1" fill="#FFFFFF"></path>
            </g>
          </g>
        </g>
      </svg>

      <svg v-else width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="search---results---list" transform="translate(-1321.000000, -394.000000)" fill="#333333">
            <g id="Group-4" transform="translate(1321.000000, 394.000000)">
              <rect id="Rectangle-55" fill="#FFFFFF" x="47" y="0" width="45" height="45"></rect>
              <path d="M12,16 L18,16 L18,10 L12,10 L12,16 Z M21,16 L27,16 L27,10 L21,10 L21,16 Z M30,10 L30,16 L36,16 L36,10 L30,10 Z M12,25 L18,25 L18,19 L12,19 L12,25 Z M21,25 L27,25 L27,19 L21,19 L21,25 Z M30,25 L36,25 L36,19 L30,19 L30,25 Z M12,34 L18,34 L18,28 L12,28 L12,34 Z M21,34 L27,34 L27,28 L21,28 L21,34 Z M30,34 L36,34 L36,28 L30,28 L30,34 Z"
                id="Fill-1"></path>
            </g>
          </g>
        </g>
      </svg>
    </a>

    <a @click.prevent="toggleDisplay()" class="showList" :class="{ active: isActive() === 'list' }">
      <svg v-if="isActive() === 'grid'" width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="search---results---grid" transform="translate(-1373.000000, -401.000000)" fill="#333333">
            <g id="Group-4" transform="translate(1326.000000, 401.000000)">
              <rect id="Rectangle-55" fill="#FFFFFF" x="47" y="0" width="45" height="45"></rect>
              <path d="M54,15.5555556 L59.6390977,15.5555556 L59.6390977,10 L54,10 L54,15.5555556 Z M62.4586466,13.8888889 L79,13.8888889 L79,11.6666667 L62.4586466,11.6666667 L62.4586466,13.8888889 Z M54,23.8888889 L59.6390977,23.8888889 L59.6390977,18.3333333 L54,18.3333333 L54,23.8888889 Z M62.4586466,22.2222222 L79,22.2222222 L79,20 L62.4586466,20 L62.4586466,22.2222222 Z M54,32.2222222 L59.6390977,32.2222222 L59.6390977,26.6666667 L54,26.6666667 L54,32.2222222 Z M62.4586466,30.5555556 L79,30.5555556 L79,28.3333333 L62.4586466,28.3333333 L62.4586466,30.5555556 Z"
                id="Fill-1"></path>
            </g>
          </g>
        </g>
      </svg>

      <svg v-else width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="search---results---list" transform="translate(-1373.000000, -401.000000)">
            <g id="Group-4" transform="translate(1326.000000, 401.000000)">
              <rect id="Rectangle-55" fill="#0033A0" x="47" y="0" width="45" height="45"></rect>
              <path d="M56,16 L62.0902256,16 L62.0902256,10 L56,10 L56,16 Z M65.1353383,14.2 L83,14.2 L83,11.8 L65.1353383,11.8 L65.1353383,14.2 Z M56,25 L62.0902256,25 L62.0902256,19 L56,19 L56,25 Z M65.1353383,23.2 L83,23.2 L83,20.8 L65.1353383,20.8 L65.1353383,23.2 Z M56,34 L62.0902256,34 L62.0902256,28 L56,28 L56,34 Z M65.1353383,32.2 L83,32.2 L83,29.8 L65.1353383,29.8 L65.1353383,32.2 Z"
                id="Fill-1" fill="#FFFFFF"></path>
            </g>
          </g>
        </g>
      </svg>
    </a>
  </div>
</template>

<script>
    export default {
        name: 'DisplayOptions',
        props: ['toggleDisplay'],
        data() {
            return {
            //
            }
        },
        methods: {
            showGrid: function () {

            },
            showList: function () {
            //
            },
            isActive: function () {
            return this.$parent.$parent.display
            }
        }
    };
</script>

<style scoped lang="scss">
    .DisplayOptions {
        text-align: right;
        padding-right: 30px;
        position: relative;
        top: 131px;
        @include smx {
            position: static;
            text-align: left;
            margin-top: 8px;
        }

        a,
        svg {
            display: inline-block;
        }
    }
</style>
